import { useEffect, useState } from "react"
import { useDevice } from "@/app/store"
import LoadedImg from "@/app/components/LoadedImg"

export default function BgImg(props: {src: string}) {

    const { src } = props
    const device = useDevice()
    const [ rotateY, setRotateY ] = useState(0)

    useEffect(() => {
        return () => {
            window.removeEventListener('deviceorientation', rotate, false)
        }
    }, [])

    useEffect(() => {
        if (device.orientationPermission === 'granted') {
            window.addEventListener('deviceorientation', rotate, false)
        }
    }, [device.orientationPermission])


    function rotate(e: { isTrusted: boolean, gamma: number }) {
        // console.log(e)
        if (e.gamma > -30 && e.gamma < 30) {
            setRotateY(-e.gamma)
        }
    }
    
    return (
        <div
            className="relative flex-center full"
            style={{ transform: `
                scale(${device.orientationPermission === 'granted' ? 1.2 : 1 })
                translateX(${rotateY}px)
            `}}
        >
            <LoadedImg
                src={src}
                loadingClassName="bg-main/60"
                priority="high"
            />
            <div className="absolute full bg-white/20"></div>
        </div>
    )
}